export class PriceListProduct {
  id: number;
  name: string;
  article: string;
  price: number;
  weight: number;
  widthRange: string;
  heightRange: string;
  lengthRange: string;
  imageList: string[] = [];
  processingMode: ProductProcessingMode;
}

export enum ProductProcessingMode {
  PriceList,
  Estimate,
  CuttingAndEstimate,
}
